<template>
  <a-card :bordered="false">
    <!-- <div class="s_flex_bian_c m-b-10">
      <div></div>
      <a-button type="primary" ghost v-has:superUrl="()=>getLink(7)">
        验证页地址
      </a-button>
    </div> -->
    <a-form ref='form' :model='search' :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' :wrapper-col="{span:20}">
      <app-warp :title='detail.page_title'>
        <template #app-content>
          <div class="pic_content" :style="'background-color:'+detail.page_bg_color">
            <img class="width100" v-if='detail.page_bg_img' style="display: block;height:667px" :src="info.picdomain+detail.page_bg_img" alt="">
            <div class="loginForm " :style="'color:'+detail.page_btn_color">
              <div class="formTitle">
                验证
              </div>
              <div class="form-item m-b-30">
                <div>手机号</div>
                <span style="color:#D2D2D2">请输入账号</span>
              </div>
              <div class="form-item m-b-30">
                <div>验证码</div>
                <span style="color:#D2D2D2">请输入密码</span>
                <div class="right">
                  <span style="color:#F85724">（ 59 ）</span>
                  秒后 可以重新获取
                </div>
              </div>
              <div class="btn form-sub width80 marigin_lr_auto text-ac height-46 s_lin_h46 bor-rad-46" :style="'color:'+detail.page_btn_text_color+';background-color:'+detail.page_btn_color">
                确定
              </div>
            </div>
          </div>
        </template>
        <template #app-sider>
          <div class="moduleContent " style="width:95%;margin-left:20px">
            <a-form-item label="页面标题" class='mb15' name='keyword' :label-col="{span:3}" :maxlength="8" heil="限8字内">
              <a-input v-model:value="detail.page_title" placeholder="请输入导购验证" style="width:250px" :maxlength='6'>
              </a-input>
            </a-form-item>
            <a-form-item label="背景图片" class='mb15' name='keyword' :label-col="{span:3}" help="推荐尺寸750*450">
              <div class="s_flex_ali">
                <div class="width-104 height-104 s_over">
                  <material :groupType='1' :image="detail.page_bg_img" :max="1" v-on:handlechoose="(data)=>{
                    detail.page_bg_img=data}" v-on:handledel="detail.page_bg_img=''" />
                </div>
                <a-button type="link" @click='detail.page_bg_img = "/web_base_assets/guide/guide_verify_bg.png"'>恢复默认值</a-button>
              </div>
            </a-form-item>
            <a-form-item label="页面背景色" help="页面整体背景色" :label-col="{span:3}">
              <div>
                <a-input v-model:value="detail.page_bg_color" type="color" style="width:150px" />
                <a-button class="m-l-15" type="link" @click='detail.page_bg_color = "#ffffff"'>恢复默认值</a-button>
              </div>
            </a-form-item>
            <a-form-item label="按钮颜色" :label-col="{span:3}">
              <a-input v-model:value="detail.page_btn_color" type="color" style="width:150px" />
              <a-button class="m-l-15" type="link" @click='detail.page_btn_color = "#F85724"'>恢复默认值</a-button>
            </a-form-item>
            <a-form-item label="按钮文字颜色" :label-col="{span:3}">
              <a-input v-model:value="detail.page_btn_text_color" type="color" style="width:150px" />
              <a-button class="m-l-15" type="link" @click='detail.page_btn_text_color = "#ffffff"'>恢复默认值</a-button>
            </a-form-item>
          </div>
          <a-button type="primary" v-has:guidePagesSettingSubmit="update" class='m-l-20 m-t-30'>保存</a-button>
        </template>
      </app-warp>
    </a-form>
  </a-card>
  <a-modal :keyboard="false" title="复制链接" centered :width='600' :footer="null" v-model:visible="visibleUrl" destroyOnClose>
    <div class="s_flex_bian_c">
      <div class="s_bor_r_cd9 p-r-20">
        <img class="width-160 height-160" :src="link.image" alt="">
        <p class="text-ac m-t-10">微信扫一扫立即预览</p>
      </div>
      <div class="width63">
        <p class="s_c333 s_font_b fz-16">复制地址</p>
        <div class="m-t-15 m-b-15 s_flex_bian_c">
          <a-input class="width80" v-model:value="link.link" readonly></a-input>
          <a-button type="primary" ghost @click="copy(link.link)">复制</a-button>
        </div>
        <p class="s_c999 ">可将链接复制到您的公众号菜单中</p>
      </div>
    </div>
  </a-modal>
</template>
<script>
import {
  get_verification_page_config,
  update_verification_page_config
} from "@/api/guide";
import { getClientsite } from "@/api/public";
import { iscode } from "@/utils/app";
import { onMounted, ref,toRefs,reactive } from "@vue/runtime-core";
import store from "@/store";
import { message } from "ant-design-vue";
export default {
  setup() {
    const state = reactive({
      visibleUrl:false,
      link:{}
    });
    const detail = ref({
      page_title: "导购验证",
      page_bg_img: "/web_base_assets/guide/guide_verify_bg.png",
      page_bg_color: "#ffffff",
      page_btn_color: "#F85724",
      page_btn_text_color: "#ffffff",
    });
    const initData = async () => {
      let result = await get_verification_page_config()
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        detail.value = result.data;
      }
    }; // 获取地址
    const getLink = async (client_type) => {
      let result = await getClientsite({ client_type })
        .then((res) => res.data)
        .catch((error) => error);
      state.link = result.data;
      state.visibleUrl = true;
    };
        // 复制
    const copy = (link) => {
      var input = document.createElement("input"); // 直接构建input
      input.value = link; // 设置内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      message.success("复制成功");
    };
    const update = async () => {
      let result = await update_verification_page_config(detail.value)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        initData();
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      detail,
      info: store.state.user.info,
      initData,
      update,
      getLink,
      copy
    };
  },
};
</script>

<style lang="less" scoped>
@import url("//at.alicdn.com/t/font_2663552_ykd41piorhd.css");
.moduleContent {
  height: auto;
  background: #fdfdfd;
  border: 1px solid #ddd;
  padding: 20px 10px 40px 10px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  user-select: none;
}

.pic_content {
  position: relative;
  height: 100%;
  .logo {
    width: 70px;
    height: 70px;
    position: absolute;
    top: 45px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 50%;
  }
  .loginForm {
    width: 90%;
    height: calc(100% - 75px);
    background-color: #fff;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 75px;
    transform: translateX(-50%);
    padding: 30px 20px;
    font-size: 16px;
    .formTitle {
      color: #121212;
      font-size: 26px;
      font-weight: 600;
      margin-bottom: 35px;
    }
    .form-item {
      display: flex;
      color: #121212;
      padding: 12px 0;
      border-bottom: 1px solid #e8e8e8;
      > div {
        margin-right: 25px;
      }
      span {
        flex: 1;
      }
      .right {
        width: 85px;
        font-size: 12px;
        text-align: center;
        border-left: 1px solid #ebebeb;
        margin-right: 0;
        color: #999999;
      }
    }
    .dot {
      display: inline-block;
      width: 15px;
      height: 15px;
      background-color: #e7e7e7;
      margin-right: 5px;
      border-radius: 50%;
    }
  }
}

.btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
}
</style>